import Icon from "components/atoms/Icon/Icon";
import { Controller, useFormContext } from "react-hook-form";

export const FirstStep = () => {
  const formContext = useFormContext();
  return (
    <form className="md:absolute top-0 right-12 h-full flex justify-center p-5 px-0">
      <div className="flex max-h-[40px] flex-row max-w-2xl rounded-lg divide-x-2 divide-gray-600  text-white-500 overflow-hidden w-fit bg-gray-700">
        <Controller
          name="businessType"
          render={({ field }) => (
            <label className="cursor-pointer flex flex-row gap-2 items-center text-xs">
              <input
                type="radio"
                name="businessType"
                value="B2B"
                className="hidden peer"
                checked={field.value === "B2B"}
                onChange={(event) => {
                  field.onChange(event.target.value);
                  formContext.setValue("activeStep", 2);
                  formContext.resetField("rows");
                  formContext.resetField("state");
                }}
              />
              <span className="pt-3 h-full hover:bg-gray-600 flex gap-4 items-center text-center align-middle px-5 py-2 bg-gray-700 peer-checked:bg-primary-500 peer-checked:cursor-default peer-checked:font-semibold">
                <Icon name="industry" />
                B2B
              </span>
            </label>
          )}
        />
        <Controller
          name="businessType"
          render={({ field }) => (
            <label className="cursor-pointer text-xs">
              <input
                type="radio"
                name="businessType"
                value="B2C"
                className="hidden peer"
                checked={field.value === "B2C"}
                onChange={(event) => {
                  field.onChange(event.target.value);
                  formContext.setValue("activeStep", 2);
                  formContext.resetField("rows");
                  formContext.resetField("state");
                }}
              />
              <span className="pt-3 h-full  hover:bg-gray-600 flex gap-4 items-center text-center align-middle px-5 py-2 bg-gray-700 peer-checked:bg-primary-500 peer-checked:cursor-default peer-checked:font-semibold">
                <Icon name="people" />
                B2C
              </span>
            </label>
          )}
        />
      </div>
    </form>
  );
};
